<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
    <div fxFlex="45">



      <mat-card *ngIf="order" class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>Order - {{ order.statusName }}</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>


          <div class="text-right">

            <div>
              <app-customer-badges *ngIf="customer" [customer]="customer"></app-customer-badges>
            </div>

          </div>


          <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

          <!--<mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div *ngIf="customer">
                  {{ customer.firstName }} {{ customer.lastName }}
                </div>
              </mat-panel-title>
              <mat-panel-description>
                <div *ngIf="customer">
                  {{ customer.address }}, {{ customer.zipCode }} {{ customer.city }}
                </div>
              </mat-panel-description>
            </mat-expansion-panel-header>-->

          <div *ngIf="customer">
            <div class="list-item" fxLayout="row" *ngFor="let field of fields ">
              <app-content-row [entity]="customer" [field]="field"></app-content-row>
            </div>
          </div>

            <!--<div class="list-item" fxLayout="row" *ngFor="let field of orderFields ">
              <label fxFlex="35" class="secondary">{{ field.header }}</label>
              <label fxFlex="65" *ngIf="order">{{ field.cell(order) }}</label>
            </div>-->

          <!--</mat-expansion-panel>-->

          <br /><br /><br />


          <div class="list-item" fxLayout="row" >
            <label fxFlex="35" class="secondary">Reason</label>
            <label fxFlex="65" *ngIf="order">{{ order.cancellationReasonName }}</label>
          </div>
          <div class="list-item" fxLayout="row" >
            <label fxFlex="35" class="secondary">User Reason</label>
            <label fxFlex="65" *ngIf="order && order.userCancellationReasonName != null">{{ order.userCancellationReasonName }}</label>
            <label fxFlex="65" *ngIf="order && order.userCancellationReasonName == null">unknown</label>
          </div>
          <div class="list-item" fxLayout="row" >
            <label fxFlex="35" class="secondary">Comment</label>
            <label fxFlex="65" *ngIf="order">{{ order.cancellationComment }}</label>
          </div>
          <div class="list-item" fxLayout="row" >
            <label fxFlex="35" class="secondary">Cancellation date</label>
            <label fxFlex="65" *ngIf="order">{{ order.cancellationDate | date:'dd.MM.yyyy' }}</label>
          </div>
          <div class="list-item" fxLayout="row" >
            <label fxFlex="35" class="secondary">Creation date</label>
            <label fxFlex="65" *ngIf="order">{{ order.card != null ? (order.card.creationDate | date:'dd.MM.yyyy') : '-' }}</label>
          </div>
          <div class="list-item" fxLayout="row" >
            <label fxFlex="35" class="secondary">Card Token</label>
            <label fxFlex="65" *ngIf="order">{{ order.card != null ? order.card.token : '-' }}</label>
          </div>

          <div class="list-item" fxLayout="row" *ngIf="currentUserIsPartner() || currentUserIsAgent()" style="margin-top: 20px;">
            <label fxFlex="35" class="secondary">Cancellation Status</label>
            <label fxFlex="65" *ngIf="order">{{ order.cancellationStatus == 1 ? "Pending" : 'Done' }}</label>
          </div>

          <mat-form-field style="margin-top: 20px;" *ngIf="currentUserCanChangeSomething()">
            <mat-label>Cancellation Status</mat-label>
            <mat-select [formControl]="orderCancellationStatusSelect" [disabled]="disableChanges">
              <mat-option [value]="1">
                Pending
              </mat-option>
              <mat-option [value]="2">
                Done
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-raised-button color="primary" [disabled]="disableChanges" *ngIf="currentUserCanChangeSomething()"
                  (click)="save()">Save</button>



        </mat-card-content>
        <mat-card-actions align="end">


          <button mat-raised-button color="primary" [disabled]="!prevNextIds?.prevId"
                  (click)="gotoPrevCancellation()">Previous</button>
          <button mat-raised-button color="primary" [disabled]="!prevNextIds?.nextId" (click)="gotoNextCancellation()">Next</button>

        </mat-card-actions>
      </mat-card>



    </div>
    <div fxFlex="55">

      <mat-card  class="content-card" *ngIf="!currentUserIsPartner()">
        <mat-card-header>
          <mat-card-title>

            <div *ngIf="order != null && order.cancellationInvoice?.archived">
              <h5>Fees</h5>
            </div>
            <div *ngIf="order != null && !order.cancellationInvoice?.archived">
              <h5 [hidden]="order.cancellationInvoice?.isFinished">Fees</h5>
              <h5 [hidden]="!order.cancellationInvoice?.isFinished">Fees - Invoice is finished and sent</h5>
            </div>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div style="margin-top: 0px;">
            <mat-form-field>
              <mat-label>Fee type</mat-label>
              <mat-select [formControl]="selectedFee" [disabled]="!currentUserCanChangeSomething()">
                <mat-option *ngIf="showAnnualFee" [value]="1">Annual fee</mat-option>
                <mat-option *ngIf="showIssuingFee" [value]="2">Issuing fee</mat-option>
                <mat-option [value]="3">Inactivity fee</mat-option>
                <mat-option [value]="0">Other</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <button mat-raised-button color="primary" [disabled]="!feeEditEnabled" *ngIf="currentUserCanChangeSomething()"
                  (click)="addFeeToList(selectedFee.value)">add</button>

          <div style="margin-top: 25px;" *ngIf="feeArray && feeArray.controls.length > 0">
            <!--<h3>Added fees - € {{ feeSum | number: '1.2-2' }}</h3>-->

            <form [formGroup]="addedFeeForm" *ngIf="addedFeeForm">
              <div formArrayName="fees" style="padding-left: 15px;">
                <div *ngFor="let fee of feeArray.controls; let i = index;" [formGroupName]="i">
                  <mat-card style="margin-top: 15px; background: #f9f9f9;" *ngIf="!fee.value.archived">
                    <!--<mat-card-title>
                      <h6 style="margin-block-start: 0.5em; margin-block-end: 0.5em">{{ fee.value.name }}</h6>
                    </mat-card-title>-->
                    <mat-card-content>
                      <div >
                        <!--<h4>{{ fee.value.name }}</h4>-->
                        <!--<mat-form-field *ngIf="fee.value.showYesNo">
                          <mat-label>Issuing fee</mat-label>
                          <mat-select formControlName="yesNoValue" >
                            <mat-option [value]="true">yes</mat-option>
                            <mat-option [value]="false">no</mat-option>
                          </mat-select>
                        </mat-form-field>-->
                        <div fxLayout="row" fxLayoutGap="10px;">
                          <div fxFlex="25">
                            <small *ngIf="fee.value.showCustomName">Name</small><br/>
                            <mat-form-field *ngIf="fee.value.showCustomName" style="width: 160px;">
                              <input matInput formControlName="customNameValue">
                            </mat-form-field>
                            <div *ngIf="!fee.value.showCustomName">
                              <b>{{ fee.value.name }}</b>
                            </div>
                          </div>

                          <div fxFlex="25">
                            <small>Quantity</small><br/>

                            <div [hidden]="!fee.value.showMultiplikator">
                              <mat-form-field *ngIf="fee.value.showMultiplikator" style="width: 120px;">
                                <input matInput formControlName="multiplikatorValue">
                              </mat-form-field>
                            </div>
                            <div style="margin-top: 20px;" *ngIf="!fee.value.showMultiplikator">{{fee.value.multiplikatorValue}}</div>


                          </div>

                          <div fxFlex="25">
                            <small>Amount</small><br/>
                            <div [hidden]="fee.value.disableAmount">
                              <mat-form-field style="width: 120px;">
                                <input type="number" matInput [readonly]="fee.value.disableAmount" [disabled]="fee.value.disableAmount" formControlName="amountValue">
                              </mat-form-field>
                            </div>
                            <div style="margin-top: 20px;" *ngIf="fee.value.disableAmount">{{fee.value.amountValue}}</div>
                          </div>
                          <div fxFlex="20">
                            <small>&nbsp;</small><br/>
                            <div style="text-align: right">
                              <button mat-raised-button color="warn" [disabled]="!feeEditEnabled" *ngIf="currentUserCanChangeSomething()"
                                      (click)="deleteFee(i, fee)">Delete</button>
                            </div>
                          </div>
                        </div>


                        <!--<hr style="border: 1px black solid; margin-left: 0px; margin-right: 0px; margin-bottom: 25px; margin-top: 5px;" />-->
                      </div>
                    </mat-card-content>
                  </mat-card>

                </div>
                <div style="margin-top: 15px;">
                  <b>Sum:</b> € {{ feeSum | number: '1.2-2' }}
                </div>
              </div>
            </form>

          </div>


        </mat-card-content>
        <mat-card-actions align="end">

          <div *ngIf="currentUserCanChangeSomething()">
            <button mat-raised-button color="primary" [disabled]="!addedFeeForm.dirty"
                    (click)="saveFees()">Save</button>

            <button *ngIf="!order?.cancellationInvoice?.isFinished" mat-raised-button color="primary" [disabled]="(order?.cancellationInvoice != null && order?.cancellationInvoice?.archived) || addedFeeForm?.value?.fees?.length <= 0"
                    (click)="sendInvoice()">Send invoice E-Mail
            </button>

            <button *ngIf="order?.cancellationInvoice?.isFinished" mat-raised-button color="primary" [disabled]="(order?.cancellationInvoice != null && order?.cancellationInvoice?.archived) || addedFeeForm?.value?.fees?.length <= 0"
                    (click)="sendInvoice()">Send invoice E-Mail again
            </button>
          </div>
        </mat-card-actions>
      </mat-card>


      <ng-container *ngIf="isLoadingInvoices || isLoadingAnnualFeeDeductions">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-container>
      <app-customer-invoice-log-view [invs]="invoices" [annualFeeDeductions]="annualFeeDeductions" class="mt-2"></app-customer-invoice-log-view>


      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>💳 Cards</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <mat-progress-bar *ngIf="isLoadingCards" mode="indeterminate"></mat-progress-bar>
          <ng-container *ngIf="!isLoadingCards">
          <mat-accordion class="">
            <mat-expansion-panel disabled=true>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Card
                </mat-panel-title>
                <mat-panel-title>
                  Token
                </mat-panel-title>
                <mat-panel-title>
                  Expiry date
                </mat-panel-title>
                <mat-panel-title>
                  Status
                </mat-panel-title>
                <mat-panel-title>
                  Last Payment Reminder
                </mat-panel-title>
              </mat-expansion-panel-header>
            </mat-expansion-panel>
            <mat-expansion-panel *ngFor="let card of cards">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{card.product.shortName}}
                </mat-panel-title>
                <mat-panel-title>
                  {{card.token}}
                </mat-panel-title>
                <mat-panel-title>
                  {{card.expireDate | date: 'MM/yy'}}
                </mat-panel-title>
                <mat-panel-title class=" {{card.status == 6 ? 'warning-row' : ''}}">
                  {{card.statusName}}<div style="display: inline-block; margin-left: 4px; padding: 3px; background-color: dodgerblue; color: black; font-size: .8em;" *ngIf="card.reorderReason">R</div>
                </mat-panel-title>
                <mat-panel-title>
                  {{card.order.paymentEmailReminders && card.order.paymentEmailReminders[card.order.paymentEmailReminders.length - 1] | date: 'dd.MM.yyyy'}}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="list-item" fxLayout="row" *ngFor="let field of cardFields">

                <app-content-row [field]="field" [entity]="card"></app-content-row>

                <div *ngIf="field.cell(card).startsWith('&lt;a i') && !card.order.invoice">
                  <i>This card's order has no invoice</i>
                </div>


              </div>

              <div *ngIf="card.reorderReason" style="margin: 5px; padding: 5px; border-radius: 5px; background-color: dodgerblue">
                <b>This card has been re-ordered</b><br />
                <hr style="border-top: 1px solid black; border-bottom: none;" />
                <div *ngIf="card.reorderReason === cardReorderReason.LostOrStolen">Lost or stolen</div>
                <div *ngIf="card.reorderReason === cardReorderReason.CardNotArrived">Card not arrived</div>
                <div *ngIf="card.reorderReason === cardReorderReason.Expired">Expired</div>
                Comment: <i>{{ card.reorderComment }}</i>
              </div>



            </mat-expansion-panel>
          </mat-accordion>
          </ng-container>
        </mat-card-content>
      </mat-card>


    </div>
  </div>


